<template>
  <div class="elementForm" :key="`tab_content_2_disabled_` + $store.state.calculatorData.calculatorPages[2].disabled">
    <div class="row">
      <div class="col-md-7">
        <h2>{{ $t(`elementForm.title`)}}</h2>
      </div>
      <div class="col-md-5 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>
    <b-button @click="explanationClick()" v-b-toggle.explanation-content-elementForm variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-elementForm" class="explanation-content">
      <b-card>
        <p v-html="$t(`elementForm.infoText`)"></p>
        <p class="d-md-none font-size-small radio-info-text">
          <b-badge variant="warning">i</b-badge>
          Wählen für weitere Informationen
        </p>
      </b-card>
    </b-collapse>
    <div class="radio-tile-group columns-2" v-if="$store.state.calculatorData.currentOrder.insulationMaterial === 'eps'">
      <StoRadio step="elementForm" type="jak" />
      <StoRadio step="elementForm" type="jas" />
    </div>
    <div class="radio-tile-group columns-2"  v-else-if="$store.state.calculatorData.currentOrder.insulationMaterial === 'foamglas'">
      <StoRadio step="elementForm" type="jaka" />
      <StoRadio step="elementForm" type="jasa" />
    </div>

    <div class="radio-tile-group columns-2" v-else-if="$store.state.calculatorData.currentOrder.insulationMaterial === 'epsAndPlaster'">
      <StoRadio step="elementForm" type="jakp" />
      <StoRadio step="elementForm" type="jasp" />
    </div>
    <StepNavi thisPage="1" :key="`navi_tab2_`+$store.state.calculatorData.calculatorPages[2].disabled"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StoRadio from './StoRadio.vue'
import StepNavi from './StepNavi.vue'

export default {
  name: 'ElementForm',
  components: {
    StoRadio,
    StepNavi
  },
  data () {
    return {
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'currentPageNumber',
      'calculatorPages',
      'disabledStatusTab2',
      'elementForm'
    ]),
    naviKey: function () {
      let updateString = 'elementForm-naviKey'
      updateString += '_pageDisabled-' + this.disabledStatusTab2
      updateString += 'pageError-' + this.$store.getters.pageError('elementLengths')
      return updateString
    }
  },
  methods: {
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'elementForm'
        let gtmEventLabel = this.$t(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- ElementForm rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
